// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1DGMu","buttons":"PendingPaymentAlert_buttons__3tyI_"};